import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";
import { useSelector } from 'react-redux';
import { AiOutlineDelete } from "react-icons/ai";
import RichTextEditor from 'react-rte';

import { toastMessage } from '../../utils/toast';
import WarningModal from './warningModal';
import * as refundActions from '../../Redux/Actions/refunds';
import * as jobActions from '../../Redux/Actions/jobs';
import UploadRef from './uploadRef';
import { getDocumentId } from '../../utils/getDocumentId';
import pdfImg from '../../assets/images/pdf_img.png';
import { downloadFile, getDocumentLabel } from '../../utils';
import DocumentContainer from './documentContainer';
import CONFIG from '../../config';
import StatusLog from '../../utils/statusLog';

const RefundInfo = ({history, match}) => {
    const { id } = match.params;
    const userId = CONFIG.systemUserId;
    const { Role } = useSelector(({ User }) => User.data);

    const { t } = useTranslation();
    const docRef = useRef();
    const [loading, setLoading] = useState(false);
    const [selectedVal, setSelectedVal] = useState('');
    const [attachments, setAttachments] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
    const [warningModal, setWarningModal] = useState(false);
    const [attachmentId, setAttachmentId] = useState('');
    const [refundInfo, setRefundInfo] = useState();
    const [options, setOptions] = useState([]);
    const [docArr, setDocArr] = useState([]);
    const [statusLog, setStatusLog] = useState([]);
    const [comments, setComments] = useState(RichTextEditor.createEmptyValue());
    const [trackingUploadFlag, setTrackingUploadFlag] = useState(true);
    const [financeUploadFlag, setFinanceUploadFlag] = useState(true);

    useEffect(() => {
        getRefundInformation();
        getStatusFilterOptions(id);
        getRefundDocs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  

    const getRefundInformation = () => {
        setLoading(true);
        refundActions.getRefundInfo(id).then((res) => {
            if(res?.data) {
                getRefundStatusLogs(res.data?.jobId);
                setRefundInfo(res?.data);
            }
            setLoading(false);
        }).catch((err) => {
            console.log(err);
            setLoading(false);
        })
    }

    const getRefundStatusLogs = async (id) => {
        try {
            const { data } = await refundActions.refundStatusInfo(id);
            const statusInfo = data.map(({ logData, time }) => {
                let parsedLogData = JSON.parse(logData);
                return {...{ comments: parsedLogData.Commments, createdTime: time, message: parsedLogData.ToStatus }}
            });
            setStatusLog(statusInfo);
        } catch(error) {
            toastMessage('error', error?.message || 'Network Error');
        }
    }
    
    const getRefundDocs = async () => {
        try {
            const response = await refundActions.getRefundDocumentIds(id);
            const { data } = response;
            let temp = [data.completed, data.approved];
            setTrackingUploadFlag(data.approved ? false : true);
            setFinanceUploadFlag(data.completed ? false : true);
            const ids = temp.filter(item => item !== undefined && item !== null);
            let documentsArr = [];
    
            ids?.forEach(async (item) => {
                const res = await jobActions.getDocumentMetaData(userId, item);
                documentsArr.push(res?.data.pop());
                ids.length === documentsArr.length && setDocArr(documentsArr);
            });
        } catch(error) {
            toastMessage('error', error?.message || 'Network Error');
        }
    }

    const getStatusFilterOptions =  (refundId) => {
        refundActions.getRelevantRefundStautusValues(refundId).then((res) => {
            if(res?.data) {
                const options = res?.data.filter(({value}) => value !== 'RefundRequest');
                setOptions(options);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const resetState = () => {
        setButtonLoading(false);
        setSelectedVal('');
        setAttachments('');
        setAttachmentId('');
        setComments(RichTextEditor.createEmptyValue());
        setWarningModal(false);
    }

    // const handleSubmit = async () => {
    //    setButtonLoading(true);

    //     const payload = {
    //         refundId: id,
    //         status: selectedVal,
    //         attachment: attachmentId,
    //     }

    //     if(selectedVal === 'RefundReject') {
    //         payload['Comments'] = comments.toString('html');
    //     }
        
    //     try {
            // const res = await refundActions.updateStatus(payload);

    //         if(!(res?.status === 200)) {
    //             throw new Error(res);
    //         }

    //         toastMessage('success', `Refund status Updated successfully!`);
    //         resetState();
    //         getRefundInformation();
    //         getRefundDocs();
    //     } catch(err) {
    //         toastMessage('error', err?.response?.data?.message || 'Unable to upate status');
    //         resetState();
    //     }
    // }

    const handleSubmit = async () => {
        setButtonLoading(true);
 
        const payload = {
            refundId: id,
            attachment: attachmentId
          }

        const payloadAdmin = {
            refundId: id,
            status: selectedVal,
            attachments: null,
        }

        if(['RefundReject', 'RefundRejectToApproved'].includes(selectedVal)) {
            payloadAdmin['Comments'] = comments.toString('html');
        }
         
         try {
            const res = (Role === 'SUPERADMIN' || (Role === 'FINANCE' && (refundInfo?.refundStatus === 'Refund RCA Uploaded' || refundInfo?.refundStatus === 'Refund Receipt Uploaded'))) ? await refundActions.updateStatus(payloadAdmin) 
            : (Role === 'TRACKING' || (Role === 'FINANCE' && refundInfo?.refundStatus === 'Refund Requested')) 
                ? await refundActions.uploadRca(payload) 
                : await refundActions.uploadRefundReceipt(payload);

            if(!(res?.status === 200)) {
                throw new Error(res);
            }
            
            toastMessage('success', res?.data?.message || `Refund status Updated successfully!`);
            resetState();
            getRefundInformation();
            getRefundDocs();
         } catch(err) {
             toastMessage('error', err?.response?.data?.message || 'Unable to upate refund status');
             resetState();
         }
     }

    const handleWarningModal = () => {
        if (
            (Role !== "SUPERADMIN" && (refundInfo?.refundStatus === 'Refund RCA Uploaded' || refundInfo?.refundStatus === 'Refund Receipt Uploaded') && Role !== 'FINANCE') ||
            (Role === "FINANCE" && (refundInfo?.refundStatus === 'Refund Approved' || refundInfo?.refundStatus === 'Refund Requested'))
        ) {
            (id && (attachmentId)) ? setWarningModal(true) : toastMessage('error', ((Role === 'FINANCE' && refundInfo?.refundStatus === 'Refund Requested') || Role === 'TRACKING') ? 'Please upload the RCA!' : 'Please upload the payment confirmation receipt!');
        } else {
            (id && (selectedVal !== '')) ? setWarningModal(true) : toastMessage('error', 'Please Select Value');
        }
    }

    const handleUploadPaymentReceipt = async (e) => {
        if(1024 * 1024 * 7 >= e.target.files[0].size) {
            const documentId = await getDocumentId(e.target.files[0], userId, setSubmitButtonLoading, setAttachments);
        
            if(documentId?.data) 
                setAttachmentId(documentId?.data);
        } else {
            toastMessage('error', 'Please upload less than 7MB file size');
        } 
    }

    const handleDownloadPaymentReceipt = async (documentID) => {
        const payload=[{
            userId:userId,
            documentID:documentID
        }]
        try {
            const response = await jobActions.downloadDocument(payload);
            if(response) 
                downloadFile(response);
        } catch(error) {
            console.log(error);
        }
    };

    const camelCaseToWords = (str) => str.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase());

    const toolbarConfig = {
        display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
        INLINE_STYLE_BUTTONS: [
          {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
          {label: 'Italic', style: 'ITALIC'},
          {label: 'Underline', style: 'UNDERLINE'}
        ],
        BLOCK_TYPE_BUTTONS: [
          {label: 'UL', style: 'unordered-list-item'},
          {label: 'OL', style: 'ordered-list-item'}
        ]
    };

    return(
        <div className="container-fluid">
            <div className="my-4">
                <span className="card-label font-weight-bolder c-pointer" onClick={() => history.push('/refunds')}>{t("refunds.refundInfo")}</span>
                <span className="card-label font-weight-bolder mx-2">/</span>
                <span className="card-label font-weight-bolder text-dark">{id}</span>
                <button className='btn btn-primary mx-2' onClick={() =>  ['FINANCE', 'TRACKING'].includes(Role) ? history.push(`/customer_job_reports/${refundInfo.jobId}`) : history.push(`/jobs/${refundInfo.jobId}`)}>Go to JobInfo</button>
            </div>
            {loading ? <div className="d-flex align-items-center justify-content-center h-75vh"><Loader type="ThreeDots" color="#2d207d" height={40} width={40} style={{textAlign: 'center'}} /></div>
                :<div> 
                    <div className="row col-lg-12">
                        <div className="col-lg-8">
                            <div className="card card-custom card-stretch gutter-b">
                                <div className="card-header border-0 d-flex justify-content-between">
                                    <h3 className="card-title font-weight-bolder text-dark">{t("refunds.refundAmount")}</h3>
                                </div>
                                <div className='mx-2'>
                                    {refundInfo && Object.entries(refundInfo)?.map(([key, value]) => 
                                        <div className="form-group fv-plugins-icon-container" key={key} style={{marginBottom: '10px', paddingBottom: '5px', borderBottom: '1px solid #f1f5fa'}}>
                                            <span className="text-muted">{camelCaseToWords(key)} : </span> {value}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <DocumentContainer 
                                t={t} 
                                docArr={docArr} 
                                getDocumentLabel={getDocumentLabel}
                                handleDownloadPaymentReceipt={handleDownloadPaymentReceipt}
                            />
                        </div>
                        <div className="col-lg-4">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">{t("refunds.refundUpdateStatus")}</h4>
                                </div>
                                <div className="card-body">
                                    <div className="form-group fv-plugins-icon-container" style={{marginBottom: '10px', paddingBottom: '5px'}}>
                                        <span className="text-muted">Refund Status : </span> {refundInfo?.refundStatus}
                                    </div>
                                    {['SUPERADMIN', 'FINANCE'].includes(Role) && (refundInfo?.refundStatus === 'Refund RCA Uploaded' || refundInfo?.refundStatus === 'Refund Receipt Uploaded') ? <div className='m-2'>
                                        <label className='py-2'>{t("refunds.selectRefundStatus")}</label>
                                        {/* <Select options={options} value={selectedVal}onChange={setSelectedVal} defaultOption={t("refunds.selectStatus")} /> */}
                                        <select className='form-select' value={selectedVal} onClick={() => {getStatusFilterOptions(id)}} onChange={(event) => {setSelectedVal(event.target.value)}}>
                                            {options.length > 0 && <option value="" disabled={true}>{t("refunds.selectStatus")}</option>}
                                            {options.length ? options.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.lable}
                                                </option>
                                            ))  : <option>No data available</option> }
                                        </select>
                                        {(['RefundReject', 'RefundRejectToApproved'].includes(selectedVal)) &&<div className="my-3">
                                            <p className="mb-1">{t("jobsManagement.infoJob.jobStatus.comment")}*</p>
                                            <RichTextEditor className="textEditor" toolbarConfig={toolbarConfig} value={comments} onChange={value => setComments(value)} />
                                        </div>}
                                        <button className='btn btn-danger d-flex align-items-center my-3' disabled={submitButtonLoading} onClick={handleWarningModal}>
                                            {t("refunds.submit")}{submitButtonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                        </button>
                                    </div>: null}
                                   { (trackingUploadFlag && (Role === 'TRACKING' || Role === 'FINANCE')) || (financeUploadFlag && refundInfo?.refundStatus === 'Refund Approved' && Role === 'FINANCE') ? <div>
                                        <div className='my-3'>
                                        { attachments && 
                                        <img alt="Document Preview"
                                            src={ attachments?.contentType?.includes('image') ? 
                                                (attachments?.contentType?.includes('image') ? `data:image/png;base64,${attachments.content}` : pdfImg):
                                                    ((attachments?.type?.includes('image')) ? URL.createObjectURL(attachments) : pdfImg) 
                                                }
                                            style={{ width: '50%', height: 'auto', margin: '0 0 5px 0' }} 
                                        />}
                                        {!['SUPERADMIN'].includes(Role) && <div className='d-flex align-items-center mx-2'>
                                            <UploadRef documentRef={docRef} onChange={e => handleUploadPaymentReceipt(e)} />
                                            {attachmentId && <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => {setAttachmentId(''); setAttachments(''); docRef.current.value = "";}} />}
                                        </div>}
                                        {(Role === 'TRACKING' || (Role === 'FINANCE' && refundInfo?.refundStatus === 'Refund Requested')) && <span className='text-muted mx-2'>Upload RCA</span>}
                                        {Role === 'FINANCE' && refundInfo?.refundStatus === 'Refund Approved' && <span className='text-muted mx-2'>Upload Payment Receipt</span>}
                                        </div>
                                        {Role !== 'SUPERADMIN' && <button className='btn btn-danger d-flex align-items-center m-2' disabled={submitButtonLoading} onClick={handleWarningModal}>
                                            {t("refunds.submit")}{submitButtonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                        </button>}
                                    </div>: null }
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">{t("refunds.refundInfo")}</h4>
                                </div>
                                <StatusLog t={t} statusLog={statusLog}/>
                            </div>
                        </div>
                    </div>
                </div>
            } 
            { warningModal &&
                <WarningModal 
                    t={t}
                    showModal={warningModal}
                    buttonLoading={buttonLoading}
                    handleCancel={() =>  setWarningModal(false)}
                    handleOk={() => handleSubmit()}
                />
            }  
        </div>
    );
};

export default RefundInfo;